import styled from 'styled-components';

import { getGridBase, media } from '@utils/styled';

import Anchor from '@common/components/Anchor';
import Button, { BUTTON_VARIANTS } from '@common/components/Button';
import { FormControl } from '@common/components/forms';
import Typography from '@common/components/Typography';

export const Description = styled(Typography).attrs({ variant: 'paragraph1' })`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'scale', 2)};
`;

export const FormRow = styled.div`
  ${getGridBase(2)};
  ${({ theme }) => theme.getFluidSpacing('grid-gap', 'widthBased', 1)};
  width: 100%;
`;

export const FormColumn = styled.div`
  display: flex;
  grid-column: span 2;

  ${media.from800up`
    grid-column: span 1;
  `}
`;

export const SubmitButton = styled(Button).attrs({
  variant: BUTTON_VARIANTS.LEVEL_1_GREEN,
})`
  width: 100%;

  ${media.from800up`
    width: auto;
  `}
`;

export const HowToButton = styled(Anchor.Button).attrs({ type: 'button' })`
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 2)};
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 1)};
  text-align: left;
`;

export const StyledFormControl = styled(FormControl)`
  ${({ theme }) => theme.getFluidSpacing('margin-bottom', 'scale', 3)};
`;
